export enum TokenizationType {
  PaymentGateway = `PAYMENT_GATEWAY`,
  Direct = 'DIRECT',
}
